/* import __COLOCATED_TEMPLATE__ from './timeline-step-stats.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();